import { Link } from 'react-router-dom';

const ACTIVITIES = [
  {
    icon: 'ri-water-flash-line',
    title: 'Glen Falls',
    description: 'One of the most popular waterfalls near Highlands, Glen Falls is accessible via a forested trail and is a common stop for visitors with dogs. The trailhead is located a short drive from downtown Highlands.',
  },
  {
    icon: 'ri-mountain-2-line',
    title: 'Whiteside Mountain Trail',
    description: 'A well-known hiking trail near Highlands with sweeping views of the surrounding mountain landscape. Leashed dogs are welcome on the trail, making it a popular outing for pet owners.',
  },
  {
    icon: 'ri-map-2-line',
    title: 'Highlands Dog Park',
    description: 'A maintained, fenced off-leash area in Highlands where dogs can exercise freely. A convenient stop for guests staying in cabins nearby.',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Dog-Friendly Restaurants',
    description: 'Several restaurants in Highlands offer outdoor seating that welcomes dogs, making it possible to enjoy a meal while traveling with a pet. The downtown area has a number of options with accessible outdoor areas.',
  },
];

export default function NearbyActivitiesSection() {
  return (
    <section className="bg-[#FAFAF8] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Getting Out</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light mb-4">
            Dog-Friendly Things to Do Nearby
          </h2>
          <p className="text-[#5C5850] font-jost text-sm max-w-2xl mx-auto leading-relaxed">
            Highlands and the surrounding area offer a range of outdoor activities that are well suited for visitors with dogs.
            For a full guide, visit our{' '}
            <Link to="/dog-friendly-highlands-nc" className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#1e3329] transition-colors cursor-pointer">
              dog-friendly Highlands NC
            </Link>{' '}
            page, or explore the complete{' '}
            <Link to="/things-to-do" className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#1e3329] transition-colors cursor-pointer">
              things to do in Highlands NC
            </Link>{' '}
            guide.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {ACTIVITIES.map((activity) => (
            <div key={activity.title} className="bg-[#F5F1EB] rounded-2xl p-7 flex gap-5">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#EDE8E0] shrink-0 mt-0.5">
                <i className={`${activity.icon} text-[#2D4A3E] text-lg`} />
              </div>
              <div>
                <h3 className="font-cormorant text-2xl text-[#1A1A18] font-medium mb-2">{activity.title}</h3>
                <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{activity.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#F5F1EB] rounded-2xl p-8 max-w-3xl mx-auto text-center">
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed">
            Highlands, North Carolina is a strong destination for dog owners thanks to its trails, waterfalls, mountain setting, and range of pet-friendly lodging options. Most outdoor areas within the Highlands area are accessible with leashed dogs.
          </p>
        </div>
      </div>
    </section>
  );
}
